import { useContext, useCallback } from 'react';
import { AjaxContext, formatListData } from 'commons-ui';
import _get from 'lodash/get';
import { EContentType } from './spotlights/utils/types';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const getMemesData = useCallback(
		async ({
			pageDetails,
			app,
			sortDetails,
			filterDetails
		}: {
			pageDetails: { pageNo: number; pageSize: number };
			app: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { appName } = app;
			const result = await postData({
				endpoint: '/marketing/dashboard/social/getAllMemePosts',
				queryParams: {
					appName
				},
				body: {
					page: { pageNo: pageDetails.pageNo, pageSize: pageDetails.pageSize },
					filters: filterDetails,
					sortInfoArray: sortDetails
				}
			});
			const data = _get(result, ['data', 'memePosts'], []);
			const rowCount = _get(result, ['data', 'count'], 0);
			const listData = formatListData(data);
			return { rowCount, data: listData, extra: pageDetails };
		},
		[]
	);

	const requestCreateMeme = useCallback((appName: string, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/social/createNewMemePost',
			body: data,
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateMeme = useCallback((appName: string, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/social/updateMemePost',
			body: data,
			queryParams: {
				appName
			}
		});
	}, []);

	const listContent = useCallback(
		async ({
			pageDetails,
			app,
			sortDetails,
			filterDetails
		}: {
			pageDetails: { pageNo: number; pageSize: number };
			app: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { appName } = app;
			const result = await postData({
				endpoint: '/marketing/dashboard/social/listContent',
				queryParams: {
					appName
				},
				body: {
					type: EContentType.SPOTLIGHT,
					page: { pageNo: pageDetails.pageNo, pageSize: pageDetails.pageSize },
					filters: filterDetails,
					sortInfoArray: sortDetails
				}
			});
			const data = _get(result, ['data', 'data'], []);
			const rowCount = _get(result, ['data', 'count'], 0);
			const listData = formatListData(data);
			return { rowCount, data: listData, extra: pageDetails };
		},
		[]
	);

	const requestCreateSpotlight = useCallback((appName: string, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/social/createContent',
			body: { data, type: EContentType.SPOTLIGHT },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateSpotlight = useCallback((appName: string, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/social/updateContent',
			body: { data, type: EContentType.SPOTLIGHT },
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		getMemesData,
		requestCreateMeme,
		requestUpdateMeme,
		listContent,
		requestCreateSpotlight,
		requestUpdateSpotlight
	};
};

export default useService;
